import blobToBase64 from "./img-to-base64";
export const viewFile = async (file) => {
  const base64 = await blobToBase64(file);
  const blob = base64.split(",");
  const fileWindow = window.open("");
  fileWindow.document.write(
    "<title>" +
    file.name +
    "</title>" +
    '<body style="overflow: hidden; margin: 0">' +
    '<object width="100%" width="-webkit-fill-available" height="100%" height="-webkit-fill-available" type="application/pdf" data="' +
    encodeURI(blob) +
    '"></object>' +
    "</body>"
  );
}